import App from 'antd/lib/app'
import { WorkbenchLayout, WorkbenchLayoutPropsType } from './WorkbenchLayout'

export const WorkbenchLayoutContainer = (props: WorkbenchLayoutPropsType) => {
    return (
        <App>
            <WorkbenchLayout {...props} />
        </App>
    )
}
